// CaixaVazia.js — a ilustração de "não encontramos nada".
//
// Aparece quando uma busca não devolve resultado, quando um filtro zera a
// lista e na página 404. É o momento em que o site menos pode PARECER
// quebrado, então ela precisa ler bem nos dois temas.
//
// Duas coisas mudaram em relação às cópias que ela substitui (havia duas,
// byte a byte iguais, em GridProduto.js e AutoresGrid.js):
//
//  1. As cinco cores eram literais (#3b3a8c, #5557c4, #2a2a78, #34349a,
//     #1f1f5a). No tema claro a caixa continuava navy escura sobre o papel
//     bege — um bloco escuro no meio de uma tela clara, justamente na hora
//     em que a pessoa já está frustrada. Agora as faces saem de
//     --c-navy-mid / --c-navy-soft / --c-navy-deep, que têm valor nos dois
//     temas, e no claro ela vira uma caixa clara desenhada em cima do papel.
//
//  2. `currentColor` no contorno: quem monta a tela escolhe a cor do traço
//     pela classe de texto do container, sem prop nova.
//
// `aria-hidden`: é decoração. A explicação de que não há resultado está no
// texto ao lado, que é o que o leitor de tela precisa ouvir.
import React from "react";

const CaixaVazia = ({ className = "", largura = 220 }) => (
  <svg
    width={largura}
    height={(largura * 180) / 220}
    viewBox="0 0 220 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
  >
    {/* Silhueta inteira, mais escura, para a caixa ter contorno mesmo quando
        as faces ficam claras demais (tema claro). */}
    <path
      d="M110 30 L195 75 L195 140 L110 175 L25 140 L25 75 Z"
      fill="rgb(var(--c-navy-mid))"
      opacity="0.85"
    />
    {/* Tampa aberta: a face mais clara das três, é o que dá o volume. */}
    <path d="M110 30 L195 75 L110 110 L25 75 Z" fill="rgb(var(--c-navy-light) / 0.55)" />
    {/* Lateral direita (na sombra) e lateral esquerda (meia-luz). */}
    <path d="M110 110 L195 75 L195 140 L110 175 Z" fill="rgb(var(--c-navy-deep))" />
    <path d="M110 110 L25 75 L25 140 L110 175 Z" fill="rgb(var(--c-navy-soft))" />
    {/* O vazio lá dentro. */}
    <path
      d="M70 95 L110 75 L150 95 L150 130 L110 150 L70 130 Z"
      fill="rgb(var(--c-bg))"
      opacity="0.7"
    />
    {/* Arestas: é o que segura o desenho no tema claro, onde as faces ficam
        quase da mesma cor. */}
    <path
      d="M110 30 L195 75 L195 140 L110 175 L25 140 L25 75 Z M110 30 L110 110 M110 110 L195 75 M110 110 L25 75"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
      opacity="0.35"
      fill="none"
    />
  </svg>
);

export default CaixaVazia;
